import { getCrossBrowserFullscreenEnabled } from 'util/fullscreen';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { LocalVideoTrack, Participant, RemoteVideoTrack } from 'livekit-client';
import { FullscreenContext, FullscreenContextOptions } from 'contexts';
import { ScreenShare } from 'features/ScreenShare';
import { ControlsPanel } from 'features/Room/components';
import { useDoubleClick } from 'ui/hooks/useDoubleClick';
import { useVideoQualityByParticipantCount } from 'hooks/useVideoQualityByParticipantCount';
import { isElectron } from '@web-chat-core/ui-kit/helpers/electron';
import { StageProps } from '../types';
import { Toolbar } from './components/Toolbar';
import { MobileParticipantsList } from './components/MobileParticipantsList/MobileParticipantsList';
import {
    ControlsArea,
    HeaderLayout,
    MainLayout,
    MobileFullscreenButton,
    SidebarLayout,
    SpeakerMobileLayout,
} from './view';

type ScreenShareStageProps = StageProps & {
    participants: Participant[];
    screenTrack: LocalVideoTrack | RemoteVideoTrack;
};

export const MobileScreenShareStage = ({
    roomState,
    controlRenderer,
    onLeave,
    participants,
    screenTrack,
}: ScreenShareStageProps) => {
    const { t } = useTranslation();
    const { setFullscreenActive } = useContext<FullscreenContextOptions>(FullscreenContext);
    const isFullscreenEnabled = getCrossBrowserFullscreenEnabled();
    const enableScreenShare = isElectron ? true : false;

    const ref = useDoubleClick({
        callback: setFullscreenActive,
    });

    const { room } = roomState;

    useVideoQualityByParticipantCount();

    // TODO: Demo modernization. Невозможная ситуация, подумать как лучше убрать.
    if (!room) {
        return <div>{t('web_call_room_closed')}</div>;
    }

    const ControlRenderer = controlRenderer ?? ControlsPanel;

    return (
        <SpeakerMobileLayout>
            <HeaderLayout>
                <Toolbar participants={participants} />
            </HeaderLayout>

            <MainLayout ref={ref}>
                <ScreenShare track={screenTrack} isAuthorShown />
                {isFullscreenEnabled && <MobileFullscreenButton onClick={setFullscreenActive} isHidden={false} />}
            </MainLayout>

            <SidebarLayout>
                <MobileParticipantsList participants={participants} room={room} />
            </SidebarLayout>

            <ControlsArea>
                <ControlRenderer room={room} enableScreenShare={enableScreenShare} onLeave={onLeave} />
            </ControlsArea>
        </SpeakerMobileLayout>
    );
};
